import React, { Component } from 'react';
import Table, {TableColumn} from "./Table";
import TableCell from "./TableCell";
import {Difference} from "../models/ProcessorItemDifferenceSummary";

interface ProcessorDifferencesTableProps {
    differences: Difference[];
}

interface ProcessorDifferencesTableState {
}

const columns: TableColumn[] = [
    {
        title: "Change Type",
        flex: 1,
        propertyPath: "ChangeType"
    },
    {
        title: "label",
        flex: 1,
        propertyPath: "label"
    },
    {
        title: "Change",
        flex: 10,
        propertyPath: "change"
    }
];

export class ProcessorDifferencesTable extends Component<ProcessorDifferencesTableProps, ProcessorDifferencesTableState> {
    static displayName = ProcessorDifferencesTable.name;

    constructor(props: ProcessorDifferencesTableProps) {
        super(props);

        this.state = {
        }
    }

    async componentDidMount() {
    }

    async componentDidUpdate(prevProps: Readonly<ProcessorDifferencesTableProps>, prevState: ProcessorDifferencesTableState) {
    }


    cellForColumn = (difference: Difference, column: TableColumn, columnIndex: number) =>
    {
        
        if(column.propertyPath === "label")
        {
            return (
                <TableCell flex={column.flex}>
                    <span>From:</span>
                    <span>To:</span>
                </TableCell>
            )
        }
        if(column.propertyPath === "change")
        {
            return (
                <TableCell flex={column.flex}>
                    <span>{difference.From}</span>
                    <span>{difference.To}</span>
                </TableCell>
            )
        }
    }

    render() {
        return (
            <Table items={this.props.differences} columns={columns} cellForColumn={this.cellForColumn}/>
        );
    }
}